module.exports = __webpack_public_path__ + "img/qilin-stage5-sulking.ce7fd818.png";